export const shouldRenderOnCurrentView = (
  isMobile: boolean,
  shouldShowOnDesktop: boolean,
  shouldShowOnMobile: boolean
) => (isMobile && shouldShowOnMobile) || (!isMobile && shouldShowOnDesktop);
